var map = {
	"./Card.vue": 69889,
	"./Item.vue": 34111,
	"./ItemGroup.vue": 12579,
	"./ItemSubGroup.vue": 86021,
	"./MaterialAlert.vue": 29556,
	"./MaterialCard.vue": 97009,
	"./MaterialChartCard.vue": 9254,
	"./MaterialSnackbar.vue": 430,
	"./MaterialStatsCard.vue": 36258,
	"./MaterialTabs.vue": 34245,
	"./MaterialTestimony.vue": 68813,
	"./Subheading.vue": 41348,
	"./VComponent.vue": 4078,
	"./baseTable.vue": 41827,
	"./baseTable4.vue": 18740,
	"./basetable2.vue": 9706,
	"./imageInputFile.vue": 71208,
	"./pagination.vue": 31075,
	"./secondSpinner.vue": 74278,
	"./spinner.vue": 50972,
	"./tableDeleteModal.vue": 8599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25190;